import type { ScheduleLayout, ScheduleSearchPartial } from '@flocasts/experience-service-types'

export const isScheduleSearchPartial = (
  content: ScheduleLayout | ScheduleSearchPartial | null | undefined
): content is ScheduleSearchPartial => {
  return !!content && 'data' in content
}
